import React from 'react';

import PropTypes from 'prop-types';

import { styled, Grid, Row, Col } from '@smooth-ui/core-sc';

import bg from './images/header@2x.jpg';

const BgHeaderBg = styled.section`
  background-image: url(${bg});
  background-size: 100% auto;
  background-position: top center;
  background-repeat: no-repeat;
  background-color: #20335d;
  color: #fff;
  width: 100%;
  min-height: 230px;
  padding-top: 50px;

  p,
  a {
    color: white;
  }
`;

const BgHeader = ({ children, className }) => {
  return (
    <BgHeaderBg className={className}>
      <Grid>
        <Row justifyContent="center">
          <Col>{children}</Col>
        </Row>
      </Grid>
    </BgHeaderBg>
  );
};

BgHeader.propTypes = {
  children: PropTypes.element,
  className: PropTypes.string,
};

BgHeader.defaultProps = {
  children: null,
  className: '',
};

export default BgHeader;
